import { useEffect, useState } from "react";

const NAV_LINKS = [
  { href: "#about", label: "About" },
  { href: "#education", label: "Education" },
  { href: "#certificates", label: "Certificates" },
  { href: "#skills", label: "Skills" },
  { href: "#projects", label: "Projects" },
  { href: "#contact", label: "Contact" },
];

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 12);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-500 ${
        isScrolled
          ? "bg-[#081712]/85 backdrop-blur-md border-b border-[#D4AF6A]/20 shadow-[0_10px_40px_-20px_rgba(0,0,0,0.8)]"
          : "bg-gradient-to-b from-black/40 to-transparent border-b border-transparent"
      }`}
    >
      <nav className="container mx-auto flex justify-between items-center px-6 md:px-10 py-5">
        <a
          href="#top"
          className="font-display text-2xl tracking-wide text-gold-gradient font-medium"
        >
          Hadda Hassani
        </a>

        <button
          className="p-2 md:hidden text-[#F1E9D8]"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>

        <ul className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((link, i) => (
            <li key={link.href} className="flex items-center gap-10">
              <a
                href={link.href}
                className="link-sweep text-sm text-[#93A894] hover:text-[#D4AF6A] transition-colors duration-300"
              >
                {link.label}
              </a>
              {i < NAV_LINKS.length - 1 && (
                <span className="w-1 h-1 rounded-full bg-[#D4AF6A]/30" />
              )}
            </li>
          ))}
        </ul>
      </nav>

      <div
        className={`fixed inset-0 bg-black/70 backdrop-blur-sm transition-opacity duration-300 md:hidden ${
          isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={() => setIsOpen(false)}
      >
        <div
          className={`fixed top-0 right-0 w-72 h-full bg-[#0F2419] border-l border-[#D4AF6A]/20 transform transition-transform duration-300 grain ${
            isOpen ? "translate-x-0" : "translate-x-full"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            className="p-5 text-[#F1E9D8]"
            onClick={() => setIsOpen(false)}
            aria-label="Close menu"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <ul className="flex flex-col gap-6 px-8 pt-4">
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setIsOpen(false)}
                  className="font-display text-xl text-[#F1E9D8] hover:text-[#D4AF6A] transition-colors"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </header>
  );
}
